

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
      width: '300px'
    },
    {
      key: 'provincename',
      dataIndex: 'provincename',
      title: '省份',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '质量等级',
    },
    {
      key: 'label1',
      dataIndex: 'label1',
      title: '2019年',
      width: 100,
      slot: 'select1',
    },
    {
      key: 'label2',
      dataIndex: 'label2',
      title: '2020年',
      width: 100,
      slot: 'select2',
    },
    {
      key: 'label3',
      dataIndex: 'label3',
      title: '2021年',
      width: 100,
      slot: 'select3',
    },
    {
      key: 'label4',
      dataIndex: 'label4',
      title: '成绩',
      width: 100,
      slot: 'chengji',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '评估指标',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'label1str',
      dataIndex: 'label1str',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'label2str',
      dataIndex: 'label2str',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'label3str',
      dataIndex: 'label3str',
      title: '',
      slot:'operate2021',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};

